import { useQuery, useMutation } from '@tanstack/react-query';
import { simulationApi } from '../api/simulation.api';

export function useSimulationConfig(deploymentId) {
  return useQuery({
    queryKey: ['simulation-config', deploymentId],
    queryFn: () => simulationApi.getConfig(deploymentId),
    enabled: !!deploymentId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useSimulationPredict(deploymentId) {
  return useMutation({
    mutationFn: (body) => simulationApi.predict(deploymentId, body),
  });
}

export function useSimulationOptimal(deploymentId) {
  return useMutation({
    mutationFn: (body) => simulationApi.getContextualOptimal(deploymentId, body),
  });
}
